import PlainShell from '../../../layouts/PlainShell.vue';
import UserProfile from '../views/UserProfile.vue';
import QRLanding from '../views/QRLanding.vue';

export default[{
  path: '/',
  name: 'PublicProfile',
  component: PlainShell,
  children: [{
    path: '/profile/:userid/:cvid',
    name: 'UserProfile',
    component: UserProfile,
    title: 'User Profile',
    meta: {
      allowGuest: true,
    }
  },
  {
    path: '/qr-landing/:userid',
    name: 'QRLanding',
    component: QRLanding,
    title: 'User QR',
    meta: {
      allowGuest: true,
    }
  }
],
}];